const getCsrfToken = () => {
  const match = (document.cookie || "").match(/csrftoken=([^;]+)/);
  return match ? match[1] : "";
};

const parseSearchResponse = async ({ response, errorPrefix }) => {
  let data = {};
  const retryAfter = response.headers.get("Retry-After");
  try {
    data = await response.json();
  } catch (err) {
    data = {};
  }
  if (!response.ok) {
    const error = new Error(`${errorPrefix} ${response.status}`);
    error.status = response.status;
    error.data = data;
    error.retryAfter = retryAfter;
    throw error;
  }
  return data;
};

export const searchUniversal = ({
  q,
  type = "all",
  limit = 50,
  logic = "and",
  signal = undefined
}) => {
  const params = new URLSearchParams();
  if (typeof q === "string") {
    params.set("q", q);
  }
  params.set("type", type);
  params.set("limit", String(limit));
  params.set("logic", logic === "or" ? "or" : "and");
  params.set("r", Date.now().toString(36));

  const csrfToken = getCsrfToken();
  const headers = { Accept: "application/json" };
  if (csrfToken) {
    headers["X-CSRFToken"] = csrfToken;
  }

  return fetch(`/api/search/?${params.toString()}`, {
    method: "GET",
    credentials: "same-origin",
    headers,
    signal
  }).then(response =>
    parseSearchResponse({
      response,
      errorPrefix: "Search request failed with"
    })
  );
};

export const suggestUniversalValues = ({
  key,
  prefix,
  limit = 10,
  signal = undefined
}) => {
  const params = new URLSearchParams();
  params.set("type", "all");
  params.set("limit", String(limit));
  if (typeof key === "string" && key.trim()) {
    params.set("key", key.trim());
  }
  if (typeof prefix === "string" && prefix.trim()) {
    params.set("prefix", prefix.trim());
  }
  params.set("r", Date.now().toString(36));

  const csrfToken = getCsrfToken();
  const headers = { Accept: "application/json" };
  if (csrfToken) {
    headers["X-CSRFToken"] = csrfToken;
  }

  return fetch(`/api/search/suggest/?${params.toString()}`, {
    method: "GET",
    credentials: "same-origin",
    headers,
    signal
  }).then(response =>
    parseSearchResponse({
      response,
      errorPrefix: "Suggest request failed with"
    })
  );
};
